import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from "../authentication/authentication.service";
import { LoggingService } from "../logging/logging.service";
import { LazyLoadEvent } from "../../models/DataTables/lazyLoadEvent";
import { AdsPricing, AdsPricingResponse, AdvertOrder, AdvertOrderResponse, EditAdvertOrderModel } from '../../models/inModels/Advert';

@Injectable()
export class AdvertOrderService {
  private routeCategory = '/api/user/adverts';

  constructor(
    private http: HttpClient,
	private auth: AuthenticationService,
	private logging: LoggingService
  ) { }

  search(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/search`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

  loadPricing(): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/pricings`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	get(id: number): Promise<AdvertOrderResponse> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/get/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	update(model: EditAdvertOrderModel, setToLive = false): Promise<AdvertOrderResponse> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/update/${setToLive}`, JSON.stringify(model), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	createPricing(model: AdsPricing): Promise<AdsPricingResponse> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/pricings/create`, JSON.stringify(model), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}


	updatePricing(model: AdsPricing): Promise<AdsPricingResponse> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/pricings/update`, JSON.stringify(model), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	delete(id: number): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	getDropdownList(event): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/dropdown`,JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

}



// WEBPACK FOOTER //
// ./src/app/services/business/advert-order.service.ts